import { Component, OnInit } from '@angular/core';
import { ContinueLearningItemDto, EnrollmentStatus } from '../../models/course';
import { CourseService } from '../../services/course.service';

/** Student dashboard card: the most recently active enrolled courses with a resume link. */
@Component({
  selector: 'app-continue-learning-card',
  templateUrl: './continue-learning-card.component.html',
  styleUrls: ['./continue-learning-card.component.scss'],
})
export class ContinueLearningCardComponent implements OnInit {
  readonly Status = EnrollmentStatus;
  items: ContinueLearningItemDto[] = [];
  loading = true;
  failed = false;

  constructor(private coursesApi: CourseService) {}

  ngOnInit(): void {
    this.coursesApi.continueLearning(4).subscribe({
      next: (res) => {
        this.loading = false;
        this.items = res.isSuccess ? res.value ?? [] : [];
        this.failed = !res.isSuccess;
      },
      error: () => {
        this.loading = false;
        this.failed = true;
      },
    });
  }

  link(item: ContinueLearningItemDto): (string)[] {
    return item.resumeLessonId ? ['/courses/learn', item.courseId, 'lesson', item.resumeLessonId] : ['/courses/learn', item.courseId];
  }

  initial(item: ContinueLearningItemDto): string {
    return (item.title ?? '').trim().charAt(0).toUpperCase() || '#';
  }

  round(value: number): number {
    return Math.round(value ?? 0);
  }
}
